/* BUDDY AVANZA — Página de pago cancelado / no completado
 *
 * Muestra un mensaje simple y ofrece regresar al flujo de compra.
 * NO provisiona ni valida nada. NO consulta backend.
 *
 * Query params: ?intent=<checkout_intent_id>  (informativo)
 */
import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function AvanzoPagoCancelado() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const intent = params.get("intent") || "";

  return (
    <div
      className="min-h-screen bg-gradient-to-br from-rose-50 via-white to-slate-50 flex items-center justify-center px-4"
      data-testid="avanzo-pago-cancelado-page"
    >
      <Card className="max-w-md w-full shadow-xl">
        <CardContent className="p-8 text-center">
          <div className="w-16 h-16 mx-auto rounded-full bg-rose-100 flex items-center justify-center mb-4">
            <XCircle className="w-8 h-8 text-rose-600" />
          </div>
          <h1
            className="text-2xl font-bold text-slate-900"
            data-testid="pago-cancelado-title"
          >
            Pago no completado
          </h1>
          <p className="text-slate-600 mt-3" data-testid="pago-cancelado-copy">
            No se procesó ningún cargo. Si querés intentarlo nuevamente,
            volvé al flujo de compra.
          </p>
          {intent ? (
            <p
              className="text-[11px] text-slate-400 mt-4 font-mono"
              data-testid="pago-cancelado-intent"
            >
              Ref: {intent}
            </p>
          ) : null}
          <div className="mt-6 flex flex-col gap-3">
            <Button
              className="bg-indigo-600 hover:bg-indigo-700"
              onClick={() => navigate("/avanzo/comprar")}
              data-testid="pago-cancelado-retry"
            >
              Volver a intentar
            </Button>
            <Button
              variant="ghost"
              onClick={() => navigate("/buddy-avanza")}
              data-testid="pago-cancelado-back-landing"
            >
              Ir a BUDDY AVANZA
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
